import e, { useRef as r, useEffect as n, cloneElement as t } from "react";
function o(e, r, n) {
  return (r = function (e) {
    var r = function (e, r) {
      if ("object" != typeof e || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var t = n.call(e, r || "default");
        if ("object" != typeof t) return t;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof r ? r : r + "";
  }(r)) in e ? Object.defineProperty(e, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = n, e;
}
function u(e, r) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    r && (t = t.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
var i = ["children", "onClickAway", "focusEvent", "mouseEvent", "touchEvent"],
  c = {
    click: "onClick",
    focusin: "onFocus",
    focusout: "onBlur",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    touchstart: "onTouchStart",
    touchend: "onTouchEnd"
  },
  l = parseInt(e.version.split(".")[0], 10),
  f = function f(_f) {
    var a = _f.children,
      s = _f.onClickAway,
      v = _f.focusEvent,
      p = void 0 === v ? "focusin" : v,
      d = _f.mouseEvent,
      y = void 0 === d ? "click" : d,
      b = _f.touchEvent,
      m = void 0 === b ? "touchend" : b,
      O = function (e, r) {
        if (null == e) return {};
        var n,
          t,
          o = function (e, r) {
            if (null == e) return {};
            var n = {};
            for (var t in e) if ({}.hasOwnProperty.call(e, t)) {
              if (r.includes(t)) continue;
              n[t] = e[t];
            }
            return n;
          }(e, r);
        if (Object.getOwnPropertySymbols) {
          var u = Object.getOwnPropertySymbols(e);
          for (t = 0; t < u.length; t++) n = u[t], r.includes(n) || {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
        }
        return o;
      }(_f, i),
      g = r(null),
      h = r(null),
      w = r(!1);
    n(function () {
      return setTimeout(function () {
        w.current = !0;
      }, 0), function () {
        w.current = !1;
      };
    }, []);
    var E,
      j = function j(e) {
        return function (r) {
          h.current = r.target;
          var n = null == a ? void 0 : a.props[e];
          n && n(r);
        };
      },
      P = null;
    l >= 19 ? P = (null === (E = a.props) || void 0 === E ? void 0 : E.ref) || null : "ref" in a && (P = a.ref);
    var k,
      L = (k = [g, P], function (e) {
        k.forEach(function (r) {
          "function" == typeof r ? r(e) : null != r && (r.current = e);
        });
      });
    n(function () {
      var e,
        r,
        n = null !== (e = null === (r = g.current) || void 0 === r ? void 0 : r.ownerDocument) && void 0 !== e ? e : document,
        t = function t(e) {
          w.current && (g.current && g.current.contains(e.target) || h.current === e.target || !n.contains(e.target) || s(e));
        };
      return n.addEventListener(y, t), n.addEventListener(m, t), n.addEventListener(p, t), function () {
        n.removeEventListener(y, t), n.removeEventListener(m, t), n.removeEventListener(p, t);
      };
    }, [p, y, s, m]);
    var S = c[y],
      D = c[m],
      C = c[p];
    return e.Children.only(t(a, function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var n = null != arguments[r] ? arguments[r] : {};
        r % 2 ? u(Object(n), !0).forEach(function (r) {
          o(e, r, n[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
        });
      }
      return e;
    }(o(o(o({
      ref: L
    }, C, j(C)), S, j(S)), D, j(D)), O)));
  };
f.displayName = "ClickAwayListener";
export { f as default };